import React, {useMemo} from 'react';
import moment from 'moment';
import {Table} from 'semantic-ui-react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {
  Filter,
  DefaultColumnFilter,
} from '../../../../../../common/components/tableFilters';
import {orderDateFormat} from '../../../../../../common/constants/datesFormat';
import TablePagination from '../../../../../../common/components/reactTablePagination/index';

const columnsTableWithProps = (props) => {
  return [
    {
      'Header': 'USUARIO',
      'accessor': 'username',
    },
    {
      'Header': 'NOMBRE',
      'accessor': 'name',
    },
    {
      'Header': 'CONCESIONARIO',
      'accessor': 'dealer',
    },
    {
      'Header': 'AGENCIA',
      'accessor': 'agency',
    },
    {
      'Header': 'FECHA',
      'accessor': 'createdDate',
      'Cell': ({row}) => {
        const {createdDate} = row.original;
        return moment(createdDate).format(orderDateFormat);
      },
    },
  ];
};

const BulletinRecordTable = (props) => {
  const {list} = props;
  const columnsTable = columnsTableWithProps(props);
  const data = useMemo(() => list, [list]);
  const columns = useMemo(() => columnsTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
      'autoResetFilters': false,
    },
    useFilters,
    usePagination,
    useRowSelect
  );

  return (
    <>
      <div className="table-container">
        <Table className="interactive" compact striped {...getTableProps()}>
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <Table.Row key="headers" {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign="center"
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => (
              <Table.Row key="filters" id="filters">
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell key={`filter-${index}`} textAlign="center">
                    <Filter column={column} />
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign="center">
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i}>
                    {row.cells.map((cell) => {
                      return (
                        <Table.Cell textAlign="center" {...cell.getCellProps()}>
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <TablePagination
        data={data}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default BulletinRecordTable;
